module.exports = __webpack_public_path__ + "img/nav-logo.c378840b.png";